import Flickity from 'flickity'

export default class storyCarousel {
  constructor (el) {
    const flkty = new Flickity(el, {
      cellAlign: 'center',
      imagesLoaded: true,
      contain: true,
      prevNextButtons: false,
      pageDots: false,
      watchCSS: true,
      cellSelector: '.str-Story_ImageWrapper',
      groupCells: true
    })
  }
}
